import { SDKs } from "components/Docs/Integrate";
import * as React from 'react';
export default {
  SDKs,
  React
};